import { Component, OnInit } from "@angular/core";
import { DocumentsService } from "../../../../auth/service/documents.service";
import { UtilsService } from "../../../../auth/service/utils.service";
import { ActivatedRoute, Router } from "@angular/router";
import { locale as italian } from "../../../../i18n/it";
import { AuthenticationService } from "../../../../auth/service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { ICurrentUser } from "app/auth/models/user-interface";
import { IDocumentSingle } from "app/auth/models/document-id";

@Component({
  selector: "app-single-document-view",
  templateUrl: "./user-single-document-view.component.html",
  styleUrls: ["./user-single-document-view.component.scss"]
})
export class UserSingleDocumentViewComponent implements OnInit {
  public contentHeader: IContentHeader;
  public document: IDocumentSingle = null;
  public fileToUpload: string;
  public idDocument: number;
  public currentUser: ICurrentUser;
  public documentReaded: boolean = false;
  public fileAdd: string = "";

  constructor(
    public _documentService: DocumentsService,
    public _utilService: UtilsService,
    public route: ActivatedRoute,
    public _authenticationService: AuthenticationService,
    public _routerService: Router
  ) {
    this.idDocument = Number(this.route.snapshot.paramMap.get("id"));
  }

  async ngOnInit() {
    this.currentUser = await this._authenticationService.getCurrentUser();
    await this.loadDocument();
    if (this.document) {
      this.contentHeader = {
        headerTitle: this.document.document_data.title,
        actionButton: false,
        breadcrumb: {
          type: "",
          links: [
            {
              name: "Home",
              isLink: true,
              link: "/"
            },
            {
              name: italian.data.MENU.MY_DOCUMENTS,
              isLink: true,
              link: "/dashboard/my-documents"
            },
            {
              name: this.document.document_data.title,
              isLink: false
            }
          ]
        }
      };
    }
  }

  async loadDocument() {
    this.document = await this._documentService.getUserDocument(this.idDocument, { hash: this.currentUser.hash });
    this.document.document_data.description = this.document.document_data.description.includes("users/") ? "" : this.document.document_data.description;
    this.document.file_url = await this._utilService.includeFile(this.document.path_file);
  }

  async handlerChangeFileInput(event) {
    if (!event.target.files[0]) return false;
    if (!event.target.files[0].name.toLowerCase().includes("pdf") || !event.target.files[0].type.toLowerCase().includes("pdf")) {
      this._utilService.showSWALError({ text: "PLEASE_UPLOAD_PDF_FILE" });
      event.target.value = null;
      return false;
    }
    return this._utilService.convertFileToBase64(event, async (e) => {
      return (this.fileToUpload = e.target.result);
    });
  }

  async setReadDocument() {
    const data = { having_read: 1, user_hash: this.currentUser.hash };
    this._utilService.showLoading();
    await this._documentService
      .updateUserDocument(this.idDocument, data)
      .then(async () => {
        await this.loadDocument();
        this.documentReaded = true;
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_READ_DOCUMENT" });
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_READ_DOCUMENT" });
        return false;
      });
  }

  async sendSignedDocument() {
    if (!this.fileToUpload) {
      await this._utilService.showSWALError({ text: "ERROR_FILE_REQUIRE" });
      return false;
    }
    this._utilService.showLoading();
    await this._documentService
      .send_signed_document(this.fileToUpload, this.idDocument)
      .then(async () => {
        this._utilService.hideLoading();
        await this._routerService.navigateByUrl("dashboard/my-documents");
        await this._utilService.showSWALSuccess({ text: "SUCCESS_UPLOAD_FILE_DOCUMENT" });
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_UPLOAD_FILE_DOCUMENT" });
        return false;
      });
  }

  async download(fileName: string) {
    return this._utilService.downloadPDF(fileName, this.document.document_data.title);
  }
}
